/* eslint-disable */
import Dialog, { IDialogOptions } from "~/ui/dialog";
import { createRatingCard } from "~/ui/ratingcard";
import { IEvent } from "./interfaces";
import { createReviewLicence } from "~/ui/review/licence";
import { createTimeHint, getReviewConf, isFirmFromPoi } from "~/util/review";
import { node } from "~/util/dom";
import AlternativePOIDialog from "~/ui/alternativepoidialog";
import { IEventPoiagg } from "~/interfaces";
import { sleep } from "~/util/general";
import { createDialogButton } from "~/ui/dialogbutton";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { IReviewItem } from "~/review/interfaces";
import { putReview } from "~/util/providers/review";
import { store } from "~/state/store";
import { IImage } from "~/ui/review/photosupload";
import ReviewPopup from "~/review/popupwc";

interface IRequestDialogOptions extends IDialogOptions {
	activeRequest: boolean;
	onNext: Function;
	onRated: Function;
	onInvalidRequest: Function;
	onRemoved?: Function;
	onReviewClick?: (type: "agr" | "rules") => void;
	onPoiChoiceOpen?: Function;
	onPoiChoiceSelect?: Function;
	onPoiChoiceClose?: Function;
	getFirmLog: Function;
}

export default class RequestDialog {
	_age: HTMLParagraphElement;

	_card: HTMLDivElement;

	_activeRequest: boolean;

	_onNext: Function;

	_onRated: Function;

	_onInvalidRequest: Function;

	_onRemoved: Function;

	_onReviewClick: (type: "agr" | "rules") => void;

	_onPoiChoiceOpen: Function;

	_onPoiChoiceSelect: Function;

	_onPoiChoiceClose: Function;

	_getFirmLog: Function;

	_lastEvent: IEvent;

	_lastUser: string;

	_lastRating: number;

	_dialog: Dialog;

	constructor({ activeRequest, onNext, onRated, onInvalidRequest, onRemoved, onReviewClick, onPoiChoiceOpen, onPoiChoiceSelect, onPoiChoiceClose, getFirmLog, ...args }: IRequestDialogOptions) {
		this._dialog = new Dialog({
			...args,
		});
		this._activeRequest = activeRequest;
		this._onNext = onNext;
		this._onRated = onRated;
		this._onInvalidRequest = onInvalidRequest;
		this._onRemoved = onRemoved || (() => {});
		this._onReviewClick = onReviewClick || ((type: "agr" | "rules") => {});
		this._onPoiChoiceOpen = onPoiChoiceOpen || (() => {});
		this._onPoiChoiceSelect = onPoiChoiceSelect || (() => {});
		this._onPoiChoiceClose = onPoiChoiceClose || (() => {});
		this._getFirmLog = getFirmLog || ((event) => { return {}; });
		this._dialog.dom.container.classList.add("activerequest-dialog");
	}

	async request({ event, user = "", next = false, animate = false, myReview = undefined, images = [] } : {
		event: IEvent,
		user?: string,
		next?: boolean,
		animate?: boolean,
		myReview?: IReviewItem,
		images?: Array<IImage>,
	}) {
		this._lastEvent = event;
		this._lastUser = user;
		this._dialog.dom.content.innerHTML = "";
		// titulek - pokud nedostaneme jmeno uzivatele, tak jen hlaska
		this._dialog.dom.content.appendChild(node("p", { className: "activerequest-dialog__userGreeting", innerHTML: user ? _("activerequest.title.serGreeting", { user: Mapy.Util.escapeHTML(user) }) : _("activerequest.title.waiting") }));
		this._age = node("p", { className: "activerequest-dialog__age", innerHTML: createTimeHint(CONFIG.defaultLang, event.time, true) });
		if (myReview) {
			const poi = {
				...event.data.poi.poiagg,
				myReview,
			};

			this._card = this._createCard(event, poi, myReview);

			const footer = node("div", { className: "activerequest-dialog__footer" });
			const nextButton = createDialogButton({ innerHTML: _("continue"), primary: true });

			nextButton.setAttribute("data-log-ignore", "true");
			footer.appendChild(createReviewLicence(isFirmFromPoi(event.data.poi.poiagg), this._onReviewClick));
			nextButton.addEventListener("click", () => {
				Mapy.getComponent("logger").log("reviews_edit_stars", {
					...this._getFirmLog(event),
					type: "recenze",
					starsEdit: this._lastRating === myReview.rating ? 0 : 1,
				});

				const myFakeReview = {
					...myReview,
					rating: this._lastRating,
				};
				const poi = {
					...event.data.poi.poiagg,
					myReview: myFakeReview,
				};

				this.close();

				const reviewPopup = new ReviewPopup({
					activeRequest: this._activeRequest,
					showThankYou: false,
					data: {
						...getReviewConf(poi),
						myReview: myFakeReview,
					},
					initialText: myFakeReview?.text,
					initialImages: images,
					textReview: !!myFakeReview,
					onClose: ({ myReview, wasRemoved }) => {
						if (myReview) {
							this._onRated(event, myReview);
						} else if (wasRemoved) {
							this._onRemoved();
						}
					},
					onBack: (myNewReview: IReviewItem, images: Array<IImage> = []) => {
						reviewPopup.close();
						this.open();
						this.request({
							images,
							event: this._lastEvent,
							user: this._lastUser,
							next: false,
							myReview: myNewReview,
						});
					},
					logObj: this._getFirmLog(event),
				});
			}, false);
			footer.appendChild(nextButton);
			this._dialog.dom.content.appendChild(this._age);
			this._dialog.dom.content.appendChild(this._card);
			this._dialog.dom.content.appendChild(footer);
		} else {
			this._card = this._createCard(event, event.data.poi.poiagg);
			this._dialog.dom.content.appendChild(this._age);
			this._dialog.dom.content.appendChild(this._card);
		}

		// pokud dostaneme callback na klikani na next, tak to vybuildine s tlacitkem pro dalsi akci
		if (next) {
			const footer = node("div", { className: "activerequest-dialog__footer" });
			const nextButton = createDialogButton({ innerHTML: _("activerequest.close.next") });

			nextButton.setAttribute("data-log-ignore", "true");
			footer.appendChild(createReviewLicence(isFirmFromPoi(event.data.poi.poiagg), this._onReviewClick));
			nextButton.addEventListener("click", (clickEvent: Event) => {
				clickEvent.stopPropagation();
				this._onNext(event);
			}, false);
			footer.appendChild(nextButton);
			this._dialog.dom.content.appendChild(footer);
		// jinak jen licence
		} else if (!myReview) {
			this._dialog.dom.content.appendChild(createReviewLicence(isFirmFromPoi(event.data.poi.poiagg), this._onReviewClick));
		}

		if (animate) {
			this._dialog.dom.content.classList.add("activerequest-dialog__content--hidden");
			// eslint-disable-next-line no-unused-expressions
			this._card.clientHeight;
			await sleep(0);
			this._dialog.dom.content.classList.remove("activerequest-dialog__content--hidden");
			// eslint-disable-next-line no-unused-expressions
			this._card.clientHeight;
			await sleep(300);
		}
	}

	get lastEvent() {
		return this._lastEvent;
	}

	async transitionToMessage(msg: HTMLElement) {
		// sleep pouzivame proto, ze v pripade, ze by z jakehokoliv duvodu neprobihaly CSS animace a my poslouchali na transitionend, tak by se vsechno zaseklo
		msg.classList.add("activerequest-dialog__thanks");
		msg.classList.add("activerequest-dialog__thanks--hidden");
		this._dialog.dom.content.innerHTML = "";
		this._dialog.dom.content.appendChild(msg);
		// eslint-disable-next-line no-unused-expressions
		msg.clientHeight;

		// zobrazime postupne hlasku
		msg.classList.remove("activerequest-dialog__thanks--hidden");
		// eslint-disable-next-line no-unused-expressions
		msg.clientHeight;
		await sleep(300);

		// nechame hlasku chvili videt
		await sleep(2400);

		// schovame hlasku
		msg.classList.add("activerequest-dialog__thanks--hidden");
		// eslint-disable-next-line no-unused-expressions
		msg.clientHeight;
		await sleep(300);

		// nakonec odstranime uz totalne schovanou hlasku
		msg.remove();
	}

	_createCard(event: IEvent, poi: IEventPoiagg, myReview: IReviewItem = undefined) {
		const poiWithReview = {
			...poi,
			review: {
				...event.review_data,
			},
		};

		if (myReview) {
			return createRatingCard({
				starWidth: 48,
				starOffset: 13,
				// FIXME: narovnat typy
				// @ts-ignore
				poi: poiWithReview,
				onStarsClick: async result => {
					const { user } = store.getState().user;

					// @ts-ignore
					this._lastRating = result.percent;

					// jelikoz jde zpet, tak by mel byt prihlaseny, ale pokud ne, tak to vynutime
					(user.state === "green" ? Promise.resolve() : Mapy.getComponent("login").open({
						analyticsData: {
							loginOrigin: "reviewsAdd",
							section: "reviews",
						},
						motivation: "review",
					})).then(async () => {
						await putReview({
							source: poi.source,
							poiId: poi.id,
							text: "",
							mediaIds: [],
							// @ts-ignore
							rating: result.percent,
							activeRequest: this._activeRequest,
							structuredRating: [],
						});
					});
				},
				myReview,
			});
		} else {
			return createRatingCard({
				starWidth: 48,
				starOffset: 13,
				// FIXME: narovnat typy
				// @ts-ignore
				poi: poiWithReview,
				onStructuredRating: data => {
					this.close();

					this._lastRating = data.rating;

					// eslint-disable-next-line no-new
					new ReviewPopup({
						activeRequest: this._activeRequest,
						textReview: false,
						forceRating: data.rating,
						data: {
							...getReviewConf(poiWithReview),
						},
						onClose: ({ myReview, wasRemoved }) => {
							if (myReview) {
								this._onRated(event, myReview);
							} else if (wasRemoved) {
								this._onRemoved();
							}
						},
						logObj: this._getFirmLog(event),
					});
				},
				onStarsClick: reviewResponse => {
					this.close();
					this._lastRating = reviewResponse.myReview.rating;
					const reviewPopup = new ReviewPopup({
						activeRequest: this._activeRequest,
						showThankYou: false,
						data: {
							...getReviewConf(poiWithReview),
							myReview: {
								...reviewResponse.myReview,
							},
						},
						textReview: !!reviewResponse.myReview,
						onClose: ({ myReview, wasRemoved }) => {
							if (myReview) {
								this._onRated(event, myReview);
							} else if (wasRemoved) {
								this._onRemoved();
							}
						},
						onBack: (myReview: IReviewItem, images: Array<IImage> = []) => {
							reviewPopup.close();
							this.open();
							this.request({
								images,
								event: this._lastEvent,
								user: this._lastUser,
								next: false,
								myReview,
							});
						},
						logObj: this._getFirmLog(event),
					});
				},
				...myReview ? {} : {
					onPOIChoice: () => {
						this._onPoiChoiceOpen();

						const dialog = new AlternativePOIDialog({
							onPOISelect: (newPoi: IEventPoiagg) => {
								this._onPoiChoiceSelect();

								const newCard = this._createCard(event, newPoi);

								this._card.replaceWith(newCard);
								this._card = newCard;

								dialog.close();
								dialog.destroy();
								this.open();
							},
							onClose: () => {
								this._onPoiChoiceClose();
								dialog.close();
								dialog.destroy();
								this.open();
							},
							onInvalidRequest: () => {
								dialog.close();
								dialog.destroy();

								this._onInvalidRequest();
							},
							event,
						});

						this.close();
						dialog.open();
					},
				},
				logObj: this._getFirmLog(event),
				activeRequest: this._activeRequest,
			});
		}
	}

	close() {
		this._dialog.close();
	}

	open() {
		this._dialog.open();
	}

	destroy() {
		this._dialog.destroy();
	}
}
